import React from 'react';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons';

const ConsoTermsNotice = (props) => {
    const {provider, goBack} = props;

    return (
        <Container>
            <Row>
                <Col className="p-3">
                    <p>
                        Conform Regulamentului General privind Protecția Datelor nr. 679/2016, CONSO MEDIA GROUP SRL are obligatia de a administra în condiții de siguranță și numai pentru scopurile specificate, datele personale pe care ni le furnizați despre dumneavoastră, un membru al familiei dumneavoastră ori o altă persoană.
                    </p>

                    <p>
                        Colectarea datelor dumneavoastră este necesară în vederea prelucrării lor și transmiterii către partenerii contractuali ai CONSO MEDIA GROUP SRL, instituții financiar-bancare de oferta cărora sunteți interesat/ă. Pentru detalii privind modalitațile în care datele dumneavoastră cu caracter personal sunt prelucrate de către noi, vă rugăm să accesati <Link
                        href={`${process.env.NEXT_PUBLIC_WEB}/termeni/date-personale`}
                        target="_blank"
                        alt="Politica de confidențialitate">
                            Politica de confidențialitate
                        </Link> si <Link
                        href={`${process.env.NEXT_PUBLIC_WEB}/termeni/generali`}
                        target="_blank"
                        alt="Termeni de utilizare">
                            Termenii de utilizare
                        </Link> ai portalului Conso
                        {provider=='BCR' && <>, respectiv <Link
                            href={`${process.env.NEXT_PUBLIC_ENDAPI}/assets/files/terms/privacy_policy_bcr.pdf`}
                            target="_blank"
                            alt="Termeni BCR">Politica de Confidențialitate BCR</Link></> }.
                        {provider=='UniCredit Bank' && <>, respectiv <Link
                            href={`${process.env.NEXT_PUBLIC_ENDAPI}/assets/files/terms/privacy_policy_unicredit.pdf`}
                            target="_blank"
                            alt="Termeni UniCredit Bank">Politica de Confidențialitate UniCredit Bank</Link></> }.
                    </p>

                    <p>
                        Prin completarea formularului, ești de acord să fii contactat de catre Conso Media Group SRL și instituțiile financiare la care ai aplicat, în legatura cu solicitarea ta.
                    </p>

                    <p>Înteleg că această solicitare nu reprezintă depunerea unei cereri de credit la instituția finanțatoare.</p>
                    <Button variant="outline-secondary" onClick={goBack}>
                        <FontAwesomeIcon icon={faChevronLeft} height="16" width="16" className="me-2"/>
                        Înapoi
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default ConsoTermsNotice;

